'use strict';

var $ = require('../internals/export');

var IS_PURE = require('../internals/is-pure');

var anObject = require('../internals/an-object');

var aFunction = require('../internals/a-function');

var iterate = require('../internals/iterate'); // `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom


$({
  target: 'Set',
  proto: true,
  real: true,
  forced: IS_PURE
}, {
  isDisjointFrom: function isDisjointFrom(iterable) {
    var set = anObject(this);
    var hasCheck = aFunction(set.has);
    return !iterate(iterable, function (value) {
      if (hasCheck.call(set, value) === true) return iterate.stop();
    }).stopped;
  }
});